import "./style.sass";

export const PriceSummary = ({
  selectedExams = [],
  onProceedToPayment,
  selectedPlan,
  billingCycle,
}) => {
  console.log(selectedPlan, "selectedPlanprice");
  if (!selectedPlan) {
    return null;
  }

  const cycleKey = billingCycle.toLowerCase();

  const pricing = selectedPlan?.pricing?.[cycleKey];

  const allBreakdown = pricing?.breakdown || [];

  // Show only currently selected exams
  const breakdown = allBreakdown.filter((item) =>
    selectedExams.some(
      (exam) => exam.toUpperCase() === item.course.toUpperCase(),
    ),
  );

  // Recalculate based on currently selected exams
  const total = breakdown.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0,
  );

  return (
    <section className="price-summary">
      {/* Header */}
      <div className="price-summary__header">
        <h3>Price Summary</h3>

        <span className="price-summary__count">
          {selectedExams?.length} exams
        </span>
      </div>

      <div className="price-summary__content">
        <p className="price-summary__title">SELECTED EXAMS</p>

        <div className="price-summary__exam-list">
          {breakdown.map((exam) => (
            <div className="price-summary__exam" key={exam.course}>
              <div className="price-summary__exam-name">
                <span className="price-summary__bullet" />

                <span>{exam.course}</span>
              </div>

              <span className="price-summary__price">
                <span>
                  ₹ {""} {exam.amount.toLocaleString("en-IN")}
                </span>

                {/* {exam?.amount.toLocaleString("en-IN")} */}
                {/* {Number(exam.price || 0).toLocaleString("en-IN")} */}
              </span>
            </div>
          ))}
        </div>

        {/* Subtotal */}
        <div className="price-summary__subtotal">
          <span>Subtotal</span>

          <span>₹{total.toLocaleString("en-IN")}</span>
        </div>

        {/* Total */}
        <div className="price-summary__total">
          <span>Total Amount</span>

          <strong>₹{total.toLocaleString("en-IN")}</strong>
        </div>

        {/* Button */}
        <button
          type="button"
          className="price-summary__button"
          onClick={onProceedToPayment}
        >
          Proceed to Payment
        </button>
      </div>
    </section>
  );
};
